export class Shelter {
    id;
    name;           // string
    logoImgUrl;     // img stored in firestre
    website;
}

//export default Shelter;